module.exports = __webpack_public_path__ + "img/nodejs.89ccb090.svg";